import type { ReactElement } from 'react'
import { UserList } from '@components'
import { createFileRoute } from '@tanstack/react-router'

function Users(): ReactElement { return <UserList back /> }

export const Route = createFileRoute('/settings/company_/user/')({
  component: Users,
})
